<template>
  <v-row class="ma-2">
    <v-col
      cols="12"
    >
      <RendementMoyen
        :key="`rendement-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
        :has-region-selected="hasRegions"
      />
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <PrixVente
        :key="`prixVente-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :graines-rs3-selected="grainesSelected"
        :code-graine-culturial-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <PrixEquilibre
        :key="`prixEquilibre-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-culturial-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
    >
      <TresorerieDisponible
        :key="`treso-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-culturial-selected="codeGraineSelected"
      />
    </v-col>
  </v-row>
</template>

<script>
import RendementMoyen from './rendement-moyen.vue'
import PrixVente from './prix-vente.vue'
import PrixEquilibre from './prix-equilibre.vue'
import TresorerieDisponible from './tresorerie-disponible.vue'

export default {
  name: 'BlocCulture',

  components: {PrixEquilibre, PrixVente, RendementMoyen, TresorerieDisponible},
  props: {
    anneeSelected: {
    type: String, default: null
    },
    codeGraineSelected:  {
      type: String, default: null
      },
    grainesSelected: {
        type: Array,
        default: null
      },
    hasRegions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dashboardKey () {
      return `${this.anneeSelected}-${this.codeGraineSelected}`
    }
  }
}
</script>
